import React from 'react';
import { StylesPipeHeroBanner } from './style';

export type PipaHeroBannerProps = {
  backgroundImg?: string;
};

const PipaHeroBanner = ({ backgroundImg = '' }: PipaHeroBannerProps) => {
  return (
    <StylesPipeHeroBanner backgroundImg={backgroundImg}>
      <div className="image" />
    </StylesPipeHeroBanner>
  );
};

export default PipaHeroBanner;
